import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { EventBusService } from './event-bus.service';

/**
 * Downloads files
 */
@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  /**
   * Constructor
   * @param http
   * @param eventBus
   */
  constructor(private http: HttpClient, private eventBus: EventBusService) { }

  /**
   * Initiates File download from a GET API endpoint
   * @param url
   * @param alternateFilename
   * @param overrideFilename
   * @returns
   */
  public initiateDownload(url: string, alternateFilename: string, overrideFilename: boolean): Promise<void> {
    return new Promise((resolve, reject) => {
      this.eventBus.broadcastEvent('loadingIndicator', true);
      this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(take(1)).subscribe({
        next: (response: HttpResponse<Blob>) => {
          const dataUrl = window.URL.createObjectURL(response.body);

          //we need to initialize headers before use
          (response.headers as any).lazyInit();
          const headers = response.headers;

          let filename = headers.get('content-disposition');
          if (filename && filename.indexOf('filename=') >= 0) {
            filename = filename.substring(filename.indexOf('filename=') + 'filename='.length);
            filename = decodeURIComponent(filename.replace(/\+/g, '%20'));
          }
          if (!filename) {
            filename = alternateFilename || 'Export.xlsx';
          }
          if (overrideFilename && alternateFilename) {
            filename = alternateFilename;
          }

          filename = filename.split('"').join('');

          this.download(dataUrl, filename, resolve);
        },
        error: (error) => {
          this.eventBus.broadcastEvent('loadingIndicator', false);
          reject(error);
        }
      });
    });
  }

  /**
   * Initiates File download from a POST API endpoint
   * @param url
   * @param alternateFilename
   * @param overrideFilename
   * @returns
   */
  public initiateDownloadPost(url: string, payload: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.eventBus.broadcastEvent('loadingIndicator', true);
      this.http.post(url, payload, { observe: 'response', responseType: 'blob' }).pipe(take(1)).subscribe({
        next: (response: HttpResponse<Blob>) => {
          const dataUrl = window.URL.createObjectURL(response.body);

          //we need to initialize headers before use
          (response.headers as any).lazyInit();
          const headers = response.headers;

          let filename = headers.get('content-disposition');
          if (filename && filename.indexOf('filename=') >= 0) {
            filename = filename.substring(filename.indexOf('filename=') + 'filename='.length);
            filename = decodeURIComponent(filename.replace(/\+/g, '%20'));
          }

          filename = filename.split('"').join('');

          this.download(dataUrl, filename, resolve);
        },
        error: (error) => {
          this.eventBus.broadcastEvent('loadingIndicator', false);
          reject(error);
        }
      });
    });
  }

  /**
   * create file, attach to hidden element and open hidden element
   * @param dataUrl
   * @param filename
   * @param self
   * @param resolve
   */
  private download(dataUrl: string, filename: string, resolve: (value: void | PromiseLike<void>) => void): void {
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.href = dataUrl;
    a.download = filename;
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      this.eventBus.broadcastEvent('loadingIndicator', false);

      resolve();
    }, 100);
  }
}
